import { render, staticRenderFns } from "./sidebysidectaDefault.vue?vue&type=template&id=199c8607"
import script from "./sidebysidectaDefault.vue?vue&type=script&lang=js"
export * from "./sidebysidectaDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Kirbyimage: require('/opt/build/repo/frontend/components/kirbyimage.vue').default,Kirbylink: require('/opt/build/repo/frontend/components/kirbylink.vue').default})
